import { render, staticRenderFns } from "./ProductsDetails.vue?vue&type=template&id=1b49f364&scoped=true"
import script from "./ProductsDetails.vue?vue&type=script&lang=js"
export * from "./ProductsDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetails.vue?vue&type=style&index=0&id=1b49f364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49f364",
  null
  
)

export default component.exports